<claas-app-section-header>
  <h2 class="section-title">{{ productCategoryTitle() }}</h2>
  <claas-toggle
    id="toggle-button"
    class="favorites-toggler"
    [disabled]="false"
    [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
    [checked]="isChecked()"
    [required]="false"
    [disableRipple]="true"
    [inputTop]="false"
    [size]="toggleSize.SMALL"
    [truncatedText]="true"
    (changed)="handleToggleFavouriteDocsChange($event)"
  ></claas-toggle>
</claas-app-section-header>
<div class="documents-wrapper">
  @if (isChecked() && !checkIfDocumentsIncluded()) {
    <claas-empty-favorites-list [isAppPanel]="true">
      <div class="empty-favorites-info">
        <h1 class="empty-favorites-title font-3xl">
          {{ "features.emptyFavoritesList.emptyFavoritesTitle" | translate }}
        </h1>
        <p class="empty-favorites-text font-m">
          {{
            "features.emptyFavoritesList.emptyFavoritesDocuments.emptyFavoritesText"
              | translate
          }}
        </p>
        <p class="empty-favorites-text font-m">
          {{
            "features.emptyFavoritesList.emptyFavoritesDocuments.emptyFavoritesTextCta"
              | translate
          }}
        </p>
      </div>
      <div class="favorites-toggle-wrapper">
        <claas-toggle
          id="toggle-button"
          class="favorites-toggler"
          [disabled]="false"
          [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
          [checked]="isChecked()"
          [required]="false"
          [disableRipple]="true"
          [inputTop]="false"
          [size]="toggleSize.SMALL"
          [truncatedText]="true"
          (changed)="handleToggleFavouriteDocsChange($event)"
        ></claas-toggle>
      </div>
    </claas-empty-favorites-list>
  }
  @for (documentType of showFiltered(); track documentType.title) {
    <details class="accordion" open>
      @if (!isChecked() || (isChecked() && checkIfDocumentsIncluded())) {
        <summary class="accordion-summary">
          <div class="document-header">
            <h3 class="font-m document-header-title">
              {{
                `features.product-overview.productDocumentsParams.${documentType.title}`
                  | translate
              }}
            </h3>
            <claas-icon
              [id]="''"
              [iconId]="'659461'"
              [namespace]="'storybook'"
              [iconStyle]="'bold'"
              [size]="24"
              [alt]=""
              [iconName]="'favorites'"
              [removeDefaultColor]="true"
              class="arrow-icon"
            >
            </claas-icon>
          </div>
        </summary>
      }
      <claas-data-document
        [tableData]="documentType.tableData"
        [hasAnyNewDocuments]="hasAnyNewDocuments()"
      >
      </claas-data-document>
    </details>
  }
</div>
